import { defineNuxtPlugin, useAppConfig } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  const appConfig = useAppConfig();
  nuxtApp.hook("app:created", async () => {
    const isBundle = appConfig?.__swiper?.bundled ?? true;
    if (isBundle) {
      (await import("swiper/element/bundle")).register();
    } else {
      (await import("swiper/element")).register();
    }
  });
});
